"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PetitionNotificationsGraphQLService = void 0;
const BaseGraphQLService_1 = __importDefault(require("../BaseGraphQLService"));
const queries_1 = require("./queries");
const mutations_1 = require("./mutations");
class PetitionNotificationsGraphQLService extends BaseGraphQLService_1.default {
  constructor() {
    super(...arguments);
    this.getAvailableUsers = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionNotificationUsersList, variables, options, requestOptions);
      return response.data.petitions.petition.notify.usersList;
    });
    this.getUsersInSelection = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionNotificationSelectedUsers, variables, options, requestOptions);
      return response.data.petitions.petition.notify.selectedUsers;
    });
    this.getFilters = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionNotifyFilters, variables, options, requestOptions);
      return response.data.petitions.petition.notify.filters;
    });
    this.getShortStatistics = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionNotificationShortStatistics, variables, options, requestOptions);
      return response.data.petitions.petition.notify.statistic;
    });
    this.getFullStatistics = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.query(queries_1.petitionNotificationFullStatistics, variables, options, requestOptions);
      return response.data.petitions.petition.notify.statistic;
    });
    this.sendNotification = (variables, options = {}, requestOptions = {}) => __awaiter(this, void 0, void 0, function* () {
      const response = yield this.mutate(mutations_1.sendPetitionNotification, variables, options, requestOptions);
      return response.data.petitions.petition.notify;
    });
  }
}
exports.PetitionNotificationsGraphQLService = PetitionNotificationsGraphQLService;
const petitionNotificationsGraphQLService = new PetitionNotificationsGraphQLService();
exports.default = petitionNotificationsGraphQLService;